import React from 'react'
import { CloseIcon, StyledButton, StyledDialog, StyledTypography } from 'shared'

import { BaseModalComponentType } from '../types'
import { withModal } from 'utils/providers/ModalProvider'
import modals from 'constants/modals'
import { Grid, IconButton, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import appRoutes from 'constants/routes'

const SubmissionFormSuccess = ({
  closeModal,
  isOpen,
}: BaseModalComponentType) => {
  const navigate = useNavigate()
  return (
    <StyledDialog open={isOpen} onClose={closeModal}>
      <Grid
        mb={1}
        container
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="nowrap"
      >
        <StyledTypography fontWeight="bold" fontSize="24px">
          Thank you for your submission!
        </StyledTypography>
        <IconButton onClick={closeModal}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <Typography mb={1.5}>
        We’ll review your submission and be in touch within the next 2 weeks if
        we need any revisions. Please keep an eye out for new campaigns coming
        soon!
      </Typography>
      <Grid container justifyContent="flex-end">
        <StyledButton
          onClick={() => {
            closeModal()
            navigate(appRoutes.campaigns.root)
          }}
          variant="contained"
        >
          Back to Home
        </StyledButton>
      </Grid>
    </StyledDialog>
  )
}

export default withModal(modals.submissionFormSuccess)(SubmissionFormSuccess)
